export const FIRST_PAGE = 0;

// INTERVALS (ms)
export const INTERVAL_SCREENSHOT_REFRESH = 30000;
export const INTERVAL_GENERATE_END_TIME_SLOT_FOR_TODAY = 50000;
export const INTERVAL_ONE_SECOND = 1000;
export const INTERVAL_GET_DEVICE_LOGS = 15000;
export const INTERVAL_GET_DEVICE_STATUS = 15000;
export const INTERVAL_REFRESH_DEVICE_LIST = 300000;

// TIMEOUTS (ms)
export const TIMEOUT_AUTOCOMPLETE_SEARCH = 200;

export const MOBILE_TABLET_BREAKPOINT = 1024;
export const MOBILE_MENU_DISAPPEAR_TIMEOUT = 300;

// DATEPICKER
export const DATE_PICKER_CLOSE = 250;
export const DATE_PICKER_VISIBLE = 10;
export const LAST_SEVEN_DAYS = 6;
export const LAST_THIRTY_DAYS = 29;
export const LAST_NINETY_DAYS = 89;
export const HOURS_IN_DAY_MINUS_ONE = 23;
export const MINUTES_IN_HOUR_MINUS_ONE = 59;
export const MILISECUONDS_IN_MINUTE = 999;

export const MOBILE_BREAKPOINT = 768;

// Payment Sources
export const PAYMENT_OPTIONS = [
  { ID: 1, Name: 'OTC' },
  { ID: 2, Name: 'SSBT' },
  { ID: 3, Name: 'eSSBT' },
  { ID: 4, Name: 'Online' },
  { ID: 5, Name: 'Partner' },
  { ID: 6, Name: 'Android' },
];

export const DIGITS_ONLY_REGEX = /^\d*$/;

export const CURRENCY_BORDER_COLOR = '#2487FC';
export const DEFAULT_TIMEZONE = 'Etc/UTC';

export const COLUMN_MAP: Record<string, string> = {
  GroupName: 'Group',
  LocationName: 'Location',
  DeviceName: 'Device',
  Currency: 'CCY',
};

export const HIDDEN_COLUMNS = ['GroupID', 'LocationID', 'DeviceID'];

export const ItemTypes = {
  COLUMN: 'column',
};

export const SEARCH_INPUT_DEBOUNCE_DELAY = 400;

